import React from "react";
import PropTypes from "prop-types";

export default class Lazyload extends React.Component {
  constructor(props) {
    super(props);
    this.state = { shouldLoad: this.props.loadImmediately };
    this.onLazyload = this._onLazyload.bind(this);
    this.ref = React.createRef();

    if (typeof window !== "undefined") {
      import("lazysizes");
    }
  }

  componentDidMount() {
    document.addEventListener("lazybeforeunveil", this.onLazyload);
  }

  componentWillUnmount() {
    document.removeEventListener("lazybeforeunveil", this.onLazyload);
  }

  _onLazyload(e) {
    if (this.ref.current === e.target) {
      this.setState({ shouldLoad: true });
    }
  }

  render() {
    return (
      <div className="lazyload" data-expand={this.props.expand} ref={this.ref}>
        {this.state.shouldLoad && this.props.children}
      </div>
    );
  }
}

Lazyload.defaultProps = {
  expand: 1000,
};

Lazyload.propTypes = {
  expand: PropTypes.number.isRequired,
  loadImmediately: PropTypes.bool,
};
